__turbopack_context__.v({
  "discount": "plan-header-module__1gG2oW__discount",
  "hide": "plan-header-module__1gG2oW__hide",
  "pill": "plan-header-module__1gG2oW__pill",
  "planHeader": "plan-header-module__1gG2oW__planHeader",
  "price": "plan-header-module__1gG2oW__price",
  "priceHeader": "plan-header-module__1gG2oW__priceHeader",
  "show": "plan-header-module__1gG2oW__show",
});
